import React from 'react';
import { OpenTab } from '../types';

interface CloseTabConfirmationProps {
  closeTabConfirmation: { tabName: string; index: number; position: { x: number; y: number } };
  setCloseTabConfirmation: (confirmation: null) => void;
  openTabs: OpenTab[];
  setOpenTabs: (tabs: OpenTab[]) => void;
  activeTabId: string | null;
  setActiveTabId: (id: string | null) => void;
  onCloseTab?: (customerId: string) => void;
}

export const CloseTabConfirmation: React.FC<CloseTabConfirmationProps> = ({
  closeTabConfirmation,
  setCloseTabConfirmation,
  openTabs,
  setOpenTabs,
  activeTabId,
  setActiveTabId,
  onCloseTab,
}) => {
  const handleClose = () => {
    const tabToClose = openTabs[closeTabConfirmation.index];

    if (onCloseTab && tabToClose) {
      // Use callback if provided
      onCloseTab(tabToClose.customerId);
    } else {
      // Fallback to manual handling
      const newTabs = openTabs.filter((_, i) => i !== closeTabConfirmation.index);
      setOpenTabs(newTabs);

      // If we closed the active tab, switch to another
      if (tabToClose && activeTabId === tabToClose.customerId && newTabs.length > 0) {
        setActiveTabId(newTabs[newTabs.length - 1].customerId);
      } else if (newTabs.length === 0) {
        setActiveTabId(null);
      }
    }

    setCloseTabConfirmation(null);
  };

  return (
    <>
      <div className="fixed inset-0 z-[60]" onClick={() => setCloseTabConfirmation(null)} />
      <div
        className="fixed bg-gray-800 rounded-lg shadow-2xl border border-gray-700 overflow-hidden z-[70] min-w-[220px]"
        style={{
          left: `${closeTabConfirmation.position.x}px`,
          top: `${closeTabConfirmation.position.y}px`,
          transform: 'translate(-50%, 8px)'
        }}
      >
        <div className="px-4 py-2 bg-gray-900 border-b border-gray-700">
          <p className="text-xs font-semibold text-white">Fechar aba?</p>
        </div>

        <div className="px-4 py-3">
          <p className="text-xs text-gray-400 mb-3">
            Deseja fechar <span className="text-white font-medium">{closeTabConfirmation.tabName.split(' - ')[0]}</span>?
          </p>

          <div className="flex gap-2">
            <button
              onClick={handleClose}
              className="flex-1 px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded text-xs font-medium transition-colors"
            >
              Fechar
            </button>
            <button
              onClick={() => setCloseTabConfirmation(null)}
              className="flex-1 px-3 py-1.5 bg-gray-700 hover:bg-gray-600 text-white rounded text-xs font-medium transition-colors"
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
